const careType = [
  'Servicios incluidos',
  'Servicios de pago'
];

export {careType};
